import { Button } from "@/components/ui/button";
import { RefreshCw, SearchX } from "lucide-react";

interface EmptyStateProps {
  title?: string;
  description?: string;
  showRetry?: boolean;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

function EmptyIllustration() {
  return (
    <div className="relative w-48 h-48 flex items-center justify-center">
      <div className="absolute inset-0 rounded-full bg-muted/50 animate-pulse" />
      <SearchX className="relative w-20 h-20 text-muted-foreground/60 animate-bounce" style={{ animationDuration: '2s' }} />
    </div>
  );
}

export function EmptyState({
  title = "Nenhum resultado encontrado",
  description = "Não encontramos o que você está procurando.",
  showRetry = false,
  onRetry,
  retryLabel = "Tentar novamente",
  className = "",
}: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 text-muted-foreground space-y-4 px-4 ${className}`}>
      <EmptyIllustration />
      <div className="text-center space-y-1">
        <p className="text-lg font-medium text-foreground">{title}</p>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      {showRetry && onRetry && (
        <Button variant="outline" onClick={onRetry} className="mt-4">
          <RefreshCw className="h-4 w-4 mr-2" />
          {retryLabel}
        </Button>
      )}
    </div>
  );
}

interface NotFoundStateProps {
  resourceName?: string;
  onGoBack?: () => void;
  showGoBack?: boolean;
  className?: string;
}

export function NotFoundState({
  resourceName = "recurso",
  onGoBack,
  showGoBack = true,
  className = "",
}: NotFoundStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 text-muted-foreground space-y-4 px-4 ${className}`}>
      <EmptyIllustration />
      <div className="text-center space-y-1">
        <p className="text-lg font-medium text-foreground">
          {resourceName.charAt(0).toUpperCase() + resourceName.slice(1)} não encontrado
        </p>
        <p className="text-sm text-muted-foreground">
          O {resourceName} que você está procurando não existe ou foi removido.
        </p>
      </div>
      {showGoBack && onGoBack && (
        <Button variant="outline" onClick={onGoBack} className="mt-4">
          Voltar
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
